import { useHotkeys } from "react-hotkeys-hook";
import type { HotkeyCallback } from "react-hotkeys-hook/dist/types";

// Wrapper centralizado de atajos de teclado del panel.
// Mantiene la tabla de bindings explícita y consistente.
//
// Atajos del inbox:
//   J / K   → mover entre conversaciones (abajo / arriba)
//   R       → focus en input de respuesta
//   T       → tomar conversación (state -> human)
//   B       → devolver al bot (state -> bot)
//   E       → escalar (state -> escalated)
//   /       → focus en buscador
//   ?       → mostrar modal con todos los atajos
//   esc     → cerrar modal / quitar foco
//   1..9    → switch entre filtros (a futuro)

export type HotkeyId =
  | "nav-next"
  | "nav-prev"
  | "focus-reply"
  | "take"
  | "release"
  | "escalate"
  | "focus-search"
  | "help"
  | "escape";

export const HOTKEY_BINDINGS: Record<HotkeyId, { keys: string; label: string }> = {
  "nav-next": { keys: "j", label: "Siguiente conversación" },
  "nav-prev": { keys: "k", label: "Anterior conversación" },
  "focus-reply": { keys: "r", label: "Responder" },
  take: { keys: "t", label: "Tomar conversación" },
  release: { keys: "b", label: "Devolver al bot" },
  escalate: { keys: "e", label: "Escalar" },
  "focus-search": { keys: "/", label: "Buscar" },
  help: { keys: "shift+/", label: "Ver atajos" },
  escape: { keys: "esc", label: "Cancelar / cerrar" },
};

export function usePanelHotkey(
  id: HotkeyId,
  callback: HotkeyCallback,
  enabled = true,
): void {
  const binding = HOTKEY_BINDINGS[id];
  useHotkeys(binding.keys, callback, {
    enabled,
    preventDefault: true,
    // Permitimos disparo aún si hay un input/textarea activo solo para Esc y la
    // ayuda. El resto se desactiva mientras el usuario tipea.
    enableOnFormTags: id === "escape" || id === "help",
  });
}
